var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$auth.ready())?_c('div',[(_vm.$auth.check())?_c('LoggedIn',[_vm._t("default")],2):_vm._e(),(!_vm.$auth.check())?_c('LoggedOut',[_vm._t("default")],2):_vm._e(),_c('Modals')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }